import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { SCALType } from "../../../interfaces/LicenseModel";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./view-scal360-download-release-history.component.html'),
    styles:[require('./view-scal360-download-release-history.component.css')],
    selector:'view-scal360-download-release-history'
})
export class ViewScal360DownloadReleaseHistoryComponent{
    dialogTitle='View SCAL 360 Download Release History'
    errorMessage='';
    Scal360DownloadReleaseHistory;
    SelectedCustomerLicenseDetail;
    SCALTypeEnum=SCALType
    scal360LicenseDisplayList;
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        public dialogRef:MdDialogRef<ViewScal360DownloadReleaseHistoryComponent>,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.getScal360DownloadReleaseHistory()
    }
    getScal360DownloadReleaseHistory(){
        this.isLoading=true;
        this.licenseService.viewScalDownloadReleaseHistory(this.SelectedCustomerLicenseDetail.LicenseKey).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.Scal360DownloadReleaseHistory=data.DataObject
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/view-scal360-download-release-history/view-scal360-download-release-history.component.ts